import React, { useState } from 'react';
import {
  Input,
  Popover,
  PopoverTrigger,
  PopoverContent,
  CheckboxGroup,
  Checkbox,
  Button,
} from '@heroui/react';
import { SearchIcon, SearchInputIc } from '../../../../components/icons';
import { useTranslations } from '../../../../contexts/translation.context';
import { Icon } from '@iconify/react';
import { Typography } from '../../../../components';

interface FiltersSectionProps {
  search: string;
  onSearchChange: (value: string) => void;
  visibleColumns: string[];
  onVisibleColumnsChange: (columns: string[]) => void;
  allColumns: Array<{ key: string; label: string }>;
}

const FiltersSection: React.FC<FiltersSectionProps> = ({
  search,
  onSearchChange,
  visibleColumns,
  onVisibleColumnsChange,
  allColumns,
}) => {
  const { t } = useTranslations();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  return (
    <div className="flex items-center max-md:flex-wrap gap-4 md:mb-4">
      {/* Search */}
      {/* <Input
          placeholder={t('campaignsStats.search') || 'Поиск'}
          value={search}
          variant="flat"
          onChange={(e) => onSearchChange(e.target.value)}
          endContent={<SearchIcon size={20} className="text-gray-400" />}
          classNames={{
            base: "h-10",
            input: "text-sm",
            inputWrapper: "h-10  rounded-lg bg-auth-surface "
          }}
        /> */}
      {/* <Input
          type="text"
          placeholder={t('campaignsStats.search')}
          size="sm"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          endContent={<SearchInputIc />}
          classNames={{
            mainWrapper: "w-[17.0625rem]",
            base: "w-[17.0625rem]",
            input: "text-sm",
            inputWrapper: "rounded-lg h-9 w-[17.0625rem]",
          }}
        /> */}

      {/* Visible Columns Selector */}
      <Popover isOpen={isPopoverOpen} onOpenChange={setIsPopoverOpen} placement="bottom-end">
        <PopoverTrigger>
          <Button
            variant="flat"
            className="h-10 px-3 !rounded-3 border-gray-200 bg-auth-surface hover:bg-gray-50"
            startContent={
              <Icon
                width={20}
                height={20}
                icon="solar:checklist-minimalistic-outline"
                className="text-default-400 group-data-[selected=true]:text-white"
                aria-label={t('aria.offersIcon')}
              />
            }
          >
            <span className="text-sm text-gray-700">
              {t('campaignsStats.visibleColumns') || 'Видимые параметры'}
            </span>
          </Button>
        </PopoverTrigger>
        <PopoverContent className="p-4">
          <div className="flex flex-col gap-2">
            <Typography variant="body2" className="!text-auth-muted">
              {t('campaignsStats.visibleColumns') || 'Видимые параметры'}
            </Typography>
            <CheckboxGroup
              value={visibleColumns}
              onValueChange={onVisibleColumnsChange}
              classNames={{
                wrapper: 'gap-1',
              }}
            >
              {allColumns.map((column) => (
                <Checkbox
                  key={column.key}
                  value={column.key}
                  classNames={{
                    base: '!h-6 p-0 max-w-full m-0',
                    label: 'text-sm text-gray-700',
                    wrapper: 'after:bg-blue-500 after:text-white',
                  }}
                  color="primary"
                  size="md"
                >
                  {column.label}
                </Checkbox>
              ))}
            </CheckboxGroup>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default FiltersSection;
